import axios from 'axios';
// The login action passes vuex commit helper that we will use to trigger mutations.
export default {
  async getSatuanKerja({ commit }, params) {
    try {
      const response = await axios.get(
        'satuankerja/getsatuankerja?pagenumber=' + params.page
      );

      commit('GET_SK_PAGE', response.data.data.items);
      commit('GET_TOTAL_DATA', response.data.data.total);

      return response;
    } catch (e) {
      return e;
    }
  },
  async createSatuanKerja({ commit }, params) {
    try {
      const response = await axios.post(
        'satuankerja/insertsatuankerja',
        params
      );

      return response;
    } catch (e) {
      return e;
    }
  },
};
